import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalClose() {
  return <section className="py-32 px-4 bg-[#8B7355] text-[#FBF7F4] text-center relative overflow-hidden" data-id="element-29">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-30"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-32">
          <h2 className="text-3xl md:text-5xl font-serif mb-8 leading-tight" data-id="element-33">
            La parte que nadie te vende <br data-id="element-34" />
            <span className="italic opacity-80" data-id="element-35">(pero te cambia la cara)</span>
          </h2>

          <div className="space-y-6 text-xl md:text-2xl font-light leading-relaxed opacity-90" data-id="element-36">
            <p data-id="element-37">Vas a dejar de comprar por ansiedad.</p>
            <p data-id="element-38">Porque cuando tienes un protocolo, tu cerebro baja.</p>
            <p data-id="element-39">Dejas de improvisar.</p>
            <p className="font-serif text-2xl md:text-3xl pt-4 text-[#FBF7F4]" data-id="element-40">
              Y esa calma… se nota en la piel.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}